import { ECalendarView } from '@/domain/Activities.domain';
import { TCalendarFullState } from './domain';

export const DEFAULT_CALENDAR_FULL_STATE: TCalendarFullState = {
    loading: {
        schedules: false,
        availabilityMonth: false,
        availabilityDay: false,
        availabilityDayFull: false,
    },
    schedules: {},
    tripsAvailablilityForMonth: [],
    tripsAvailablilityForDay: [],
    tripSchedules: {
        id: '',
        name: '',
        disabled: '',
        product_city_id: '',
        date: '',
        date_formatted: '',
        is_avail: false,
        is_cut_off: false,
        close_out: null,
        front_booking_disabled: null,
        rate_id: 0,
        rate_name: '',
        min_price: '',
        guest_comment_field: false,
        default_tickets: {},
        schedules: [],
        additional_options: [],
    },
    tripSingleSchedule: {
        id: '',
        name: '',
        disabled: '',
        product_city_id: '',
        date: '',
        date_formatted: '',
        is_avail: false,
        is_cut_off: false,
        close_out: null,
        front_booking_disabled: null,
        rate_id: 0,
        rate_name: '',
        min_price: '',
        default_tickets: {},
        schedule: {
            id: 0,
            time: '',
            time_full: '',
            is_disabled: '',
            valid_schedule_time: false,
            min_tickets: '',
            max_tickets: '',
            tickets_avail: 0,
            tickets_avail_for_update: 0,
            sold: '',
            min_price: '',
            not_avail: false,
            not_avail_ts: false,
            not_avail_by_close_out: false,
            has_avail_tickets: false,
            stop_sell: false,
            avail_for_admin: false,
            inventories: {},
            tickets: [],
        },
    },
    tripSettings: {
        passenger_count: undefined,
        protection_plan: undefined,
        boater_test: undefined,
        tip_amount: undefined,
        comment: '',
    },
    tripSettingsAreFilled: false,

    activities: [],
    ids: '',
    partnerSlug: '',
    viewBy: ECalendarView.ACTIVITIES,
    date: {
        from: null,
        to: null,
        week: [],
    },
    isActivitiesLoading: false,
    isTimeLoading: false,
    monthAvails: {},
    daysAvails: {},
    listToShow: [],
    icons: {},
    prices: {},
    agreements: {},
    isUseSchedules: {},
    isUseCalendar: {},
    calendarStatuses: {},
};
